import * as XLSX from 'xlsx';
import { Subject, takeUntil } from 'rxjs';
import {
  Component,
  ElementRef,
  HostBinding,
  OnInit,
  OnDestroy,
  DoCheck,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Location } from '@angular/common';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
declare let $: any;
@Component({
  selector: 'Support',
  templateUrl: './support.component.html',
  // styleUrls: ['../temp-access-admin/temp-access-admin.component.css']
})
export class SupportComponent implements OnInit, OnDestroy, DoCheck {
  constructor(
    private el: ElementRef,
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private _location: Location,
    private gurdService: GurdServiceService,
  ) {}
  Id: number = 0;
  Support: any[] = [];
  ServiceTxt: any;
  singelSupport: any;
  tiketStatus: any;
  Actions: any;
  sabtModel: FormGroup = this.formBuilder.group({
    tiTiketSubject: new FormControl(),
    strDetail: new FormControl(),
  });
  editModel = new FormGroup({
    iTiket: new FormControl(),
    tiTiketSubject: new FormControl(),
    strDetail: new FormControl(),
    iSystemUser: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    ),
    strSession: new FormControl(
      this.gurdService.decrypt(localStorage.getItem('Session')!),
    ),
  });
  ngOnInit(): void {
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.Id = params['id'];
      // this.sabtModel.controls['strUnitId'].setValue(this.Id);
    });
    this.getAllSupport();
    this.getOption();
  }
  goBack() {
    this._location.back();
  }
  getOption = async () => {
    if (this.destroyed) return;
    try {
      const resp2 = await this.post(`Tiket_GetTiketSubjects`);
      this.ServiceTxt = this.requireRows(resp2.data);
      this.sabtModel.controls['tiTiketSubject'].setValue('');
    } catch (error) {
      if (!this.destroyed) {
        this.notifyService.showError(
          error instanceof Error ? error.message : 'خطا در ارتباط با سرور',
        );
      }
    }
  };
  getAllSupport = async () => {
    if (this.destroyed) return;
    if (this.listLoading) return;
    this.listLoading = true;
    this.hasError = false;
    this.errorMessage = '';
    try {
      const session = encodeURIComponent(
        this.gurdService.decrypt(window.localStorage.getItem('Session')!),
      );
      const resp = await this.post(
        `Tiket_GetTiket4Mobile?strUnitID=${this.Id}&iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`,
      );
      if (resp.data == null) {
        throw new Error('بروز خطا در سیستم');
      }
      if (resp.data.length == 0) {
        this.notifyService.showInfo('داده ای برای نمایش موجود نیست', '');
        this.Support = this.requireRows(resp.data);
      } else {
        this.Support = this.requireRows(resp.data);
      }
    } catch (error) {
      if (!this.destroyed) {
        this.hasError = true;
        this.errorMessage =
          error instanceof Error ? error.message : 'دریافت اطلاعات ناموفق بود';
        this.notifyService.showError(
          error instanceof Error ? error.message : 'خطا در ارتباط با سرور',
        );
      }
    } finally {
      this.listLoading = false;
    }
  };
  sabt = async () => {
    if (this.destroyed) return;
    if (this.loading) return;
    try {
      var model = this.sabtModel.value;
      model.strUnitId = this.Id;
      model.iSystemUser = this.gurdService.decrypt(
        window.localStorage.getItem('ID')!,
      );
      if (model.iSystemUser == null || model.iSystemUser == '') {
        this.notifyService.showError('لطفا وارد شوید ');
        return;
      }
      if (model.tiTiketSubject == null || model.tiTiketSubject == '') {
        this.notifyService.showError('لطفا  موضوع تیکت را وارد کنید');
        return;
      }
      if (model.strDetail == null || model.strDetail == '') {
        this.notifyService.showError('لطفا  توضیحات را وارد کنید');
        return;
      }
      if (confirm('آیا از ارسال درحواست اطمینان دارید؟')) {
        const session = encodeURIComponent(
          this.gurdService.decrypt(window.localStorage.getItem('Session')!),
        );
        const resp = await this.post(
          `Tiket_SaveTiket?strSession=${session}`,
          model,
        );
        if (resp.data == -100) {
          this.notifyService.showError('لطفا وارد سیستم شوید');
          this.otherService.removeLocalStorage();
          // this.router.navigate(['/login']);
          this.router.navigate(['/login'], { queryParams: { ERR_CODE: 7 } });
          return;
        }
        if (resp.data == 0) {
          this.notifyService.showError('خطایی رخ داده');
        }
        if (resp.data == 1) {
          this.notifyService.showSuccess('با موفقیت ثبت شد');
          this.getAllSupport();
          $('#exampleModal').modal('hide');
        }
      }
    } catch (error) {
      if (!this.destroyed) {
        this.notifyService.showError(
          error instanceof Error ? error.message : 'خطا در ارتباط با سرور',
        );
      }
    }
  };
  singel = async (i: any) => {
    if (this.destroyed) return;
    if (this.loading) return;
    try {
      this.singelSupport = this.Support[i];
      const session = encodeURIComponent(
        this.gurdService.decrypt(window.localStorage.getItem('Session')!),
      );
      const resp = await this.post(
        `Tiket_GetTiketAction?iTiket=${this.singelSupport.iTiket}&iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}&strSession=${session}`,
      );
      this.Actions = this.requireRows(resp.data);
      await this.getTiketStatus(this.singelSupport.iTiket);
      this.editModel.controls['iTiket'].setValue(this.singelSupport.iTiket);
      // console.log(this.singelSupport)
      // console.log(this.Actions)
    } catch (error) {
      if (!this.destroyed) {
        this.notifyService.showError(
          error instanceof Error ? error.message : 'خطا در ارتباط با سرور',
        );
      }
    }
  };
  seprator(e: any) {
    this.otherService.insertComma(e);
  }
  Cancellation = async () => {
    if (this.destroyed) return;
    if (this.loading) return;
    try {
      if (confirm('آیا از لغو این تیکت اطمینان دارید؟')) {
        const resp = await this.post(
          `Tiket_CancelTiket?strSession=${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,
          this.singelSupport,
        );
        if (resp.data == -100) {
          this.notifyService.showError('لطفا وارد سیستم شوید');
          this.otherService.removeLocalStorage();
          // this.router.navigate(['/login']);
          this.router.navigate(['/login'], { queryParams: { ERR_CODE: 8 } });
          return;
        }
        if (resp.data == 0) {
          this.notifyService.showError('خطایی رخ داده');
        }
        if (resp.data == 1) {
          this.notifyService.showSuccess('با موفقیت لغو شد');
          this.getAllSupport();
          $('#exampleModal2').modal('hide');
        }
      }
    } catch (error) {
      if (!this.destroyed) {
        this.notifyService.showError(
          error instanceof Error ? error.message : 'خطا در ارتباط با سرور',
        );
      }
    }
  };
  guid(Id: any) {
    this.otherService.guid(Id);
  }
  getTiketStatus = async (id: any) => {
    if (this.destroyed) return;
    try {
      var model = {
        iTiket: id,
        iSystemUser: this.gurdService.decrypt(
          window.localStorage.getItem('ID')!,
        ),
        strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      };
      const resp = await this.post(`Tiket_GetTiketStatus4User`, model);
      this.tiketStatus = this.parse(resp.data);
      // console.log(this.tiketStatus)
      this.editModel.controls['tiTiketSubject'].setValue(
        this.singelSupport.tiTiketStatus,
      );
      this.editModel.controls['strDetail'].setValue(
        this.singelSupport.strDetail,
      );
    } catch (error) {
      if (!this.destroyed) {
        this.notifyService.showError(
          error instanceof Error ? error.message : 'خطا در ارتباط با سرور',
        );
      }
    }
  };
  edit = async () => {
    if (this.destroyed) return;
    if (this.loading) return;
    try {
      var model = this.editModel.value;
      const resp = await this.post(`Tiket_EditTiket`, model);
      let resParse = this.parse(resp.data);
      if (resParse.iResult == 0) {
        this.notifyService.showError(resParse.strError);
        return;
      }
      if (resParse.ISSessionExpired == true) {
        this.notifyService.showError('لطفا وارد سیستم شوید');
        this.otherService.removeLocalStorage();
        this.router.navigate(['login']);
      } else {
        $('#exampleModal2').modal('hide');
        this.getAllSupport();
        this.notifyService.showSuccess('با موفقیت ویرایش شد');
      }
    } catch (error) {
      if (!this.destroyed) {
        this.notifyService.showError(
          error instanceof Error ? error.message : 'خطا در ارتباط با سرور',
        );
      }
    }
  };
  filter_list(val: any) {
    // this.list_Result = this.list_Search.filter((el: any) => {
    //   return el.strFullName.includes(val.value) ||
    //     el.strMobile.includes(val.value) ||
    //     el.strSDate.includes(val.value) ||
    //     el.strEDate.includes(val.value)
    // });
    // if (val.value.trim() == '') {
    //   this.list_Result = this.list_Search;
    // }
  }
  private readonly destroy$ = new Subject<void>();
  private destroyed = false;
  private pendingRequests = 0;
  private listLoading = false;
  hasError = false;
  errorMessage = '';
  get loading(): boolean {
    return this.pendingRequests > 0 || this.listLoading;
  }
  get tableLoading(): boolean {
    return this.listLoading;
  }
  async onRecordAction(
    key: string,
    row: Record<string, unknown>,
  ): Promise<void> {
    if (this.loading || this.destroyed) return;
    if (key === 'details') {
      this.Actions = [];
      this.tiketStatus = [];
      $('#exampleModal2').modal('show');
      await this.singel(this.Support.indexOf(row));
    }
  }

  searchText = '';
  currentPage = 1;
  pageSize = 20;
  readonly pageSizeOptions = [10, 20, 50];
  filteredRows: Record<string, unknown>[] = [];
  pagedRows: Record<string, unknown>[] = [];

  private tableSnapshot: unknown[] = [];
  private tableIdentity = '';
  readonly tableTitle = 'پشتیبانی';
  get printId(): string {
    return `support-print-${this.Id}`;
  }
  get hasActiveFilters(): boolean {
    return !!this.searchText.trim();
  }
  get emptyTitle(): string {
    return this.hasActiveFilters
      ? 'با این فیلترها نتیجه‌ای پیدا نشد!'
      : 'اطلاعاتی برای نمایش وجود ندارد';
  }

  ngDoCheck(): void {
    const identity = `${this.Id}`;
    const rows = this.Support;
    const identityChanged = identity !== this.tableIdentity;
    if (identityChanged) this.searchText = '';
    if (
      identityChanged ||
      rows.length !== this.tableSnapshot.length ||
      rows.some((row, index) => row !== this.tableSnapshot[index])
    ) {
      this.tableIdentity = identity;
      this.refreshTable(true);
    }
  }

  onSearchChange(): void {
    if (!this.loading) this.refreshTable(true);
  }

  clearSearch(): void {
    if (this.loading) return;
    this.searchText = '';
    this.refreshTable(true);
  }

  onPageChange(page: number): void {
    if (this.loading) return;
    this.currentPage = page;
    this.refreshTable();
  }

  onPageSizeChange(size: number): void {
    if (this.loading || !this.pageSizeOptions.includes(size)) return;
    this.pageSize = size;
    this.refreshTable(true);
  }

  numberValue(value: unknown): number {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  private normalizeSearch(value: unknown): string {
    return String(value ?? '')
      .replace(/[۰-۹]/g, (digit) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)))
      .replace(/[٠-٩]/g, (digit) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)))
      .trim()
      .toLowerCase();
  }

  private refreshTable(resetPage = false): void {
    const rows = this.Support;
    this.tableSnapshot = [...rows];
    const fields = [
      'iTiket',
      'strSaveDate',
      'strSaveTime',
      'strTiketStatus_strComment',
      'strTiketSubject_strComment',
    ];
    const query = this.normalizeSearch(this.searchText);
    this.filteredRows = query
      ? rows.filter((row) =>
          this.normalizeSearch(
            fields.map((field) => row[field]).join(' '),
          ).includes(query),
        )
      : [...rows];
    this.currentPage = resetPage
      ? 1
      : Math.max(
          1,
          Math.min(
            this.currentPage,
            Math.ceil(this.filteredRows.length / this.pageSize) || 1,
          ),
        );
    this.pagedRows = this.filteredRows.slice(
      (this.currentPage - 1) * this.pageSize,
      this.currentPage * this.pageSize,
    );
  }

  exportExcel(): void {
    if (this.loading || this.hasError || !this.filteredRows.length) return;
    const headers = [
      '#',
      'شماره تیکت',
      'تاریخ',
      'زمان',
      'وضعیت تیکت',
      'موضوع تیکت',
    ];
    const rows: (string | number)[][] = this.filteredRows.map((row, index) => [
      index + 1,
      String(row['iTiket'] ?? ''),
      String(row['strSaveDate'] ?? ''),
      String(row['strSaveTime'] ?? ''),
      String(row['strTiketStatus_strComment'] ?? ''),
      String(row['strTiketSubject_strComment'] ?? ''),
    ]);
    rows.push([`تعداد کل: ${this.filteredRows.length}`, '', '', '', '', '']);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.aoa_to_sheet([headers, ...rows]),
      'Sheet1',
    );
    XLSX.writeFile(workbook, `${this.tableTitle}.xlsx`);
  }

  private parse(data: unknown): ReturnType<typeof JSON.parse> {
    return typeof data === 'string' ? JSON.parse(data) : data;
  }
  private requireRows(data: unknown): Record<string, unknown>[] {
    const parsed = this.parse(data);
    if (!Array.isArray(parsed))
      throw new Error(parsed?.strError || 'پاسخ سرور نامعتبر است');
    return parsed;
  }
  private async post(url: string, payload?: unknown) {
    if (this.destroyed) throw new Error('درخواست لغو شد');
    this.pendingRequests++;
    try {
      const response = await axios.post(url, payload);
      if (this.destroyed) throw new Error('درخواست لغو شد');
      const parsed = this.parse(response.data);
      if (
        parsed === -100 ||
        parsed?.ISSessionExpired ||
        parsed?.ISessionExpired
      ) {
        this.otherService.removeLocalStorage();
        void this.router.navigate(['login']);
        throw new Error('لطفا وارد سیستم شوید');
      }
      return response;
    } finally {
      this.pendingRequests--;
    }
  }
  ngOnDestroy(): void {
    this.destroyed = true;
    this.destroy$.next();
    this.destroy$.complete();
    $(this.el.nativeElement)
      .find('.modal')
      .off('.vehicleRecords')
      .modal('hide');
  }
}
